<template>
<div class="chapter">
<div class="inner_page">
<div class="acknowPage">
<div class="title-acknowPage"><a href="#/e9781429933148_toc01#toctitle1" id="title1"><span><strong class="b">ACKNOWLEDGMENTS</strong></span></a></div>
<div class="p"><span>I am extremely grateful to the following people:</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>Maureen Empfield, MD, and Howell Schrage, MD, for generously providing me with insights on the treatment of mental illness, the administration of a psychiatric hospital, the use of antipsychotic drugs, and so on;</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>Tim Scheld, one of New York’s best and busiest radio reporters, for helping me get into some of the city’s off-limit locations;</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>Richard Scofield, MD, for his kindness in providing free medical advice to fictional characters;</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>my wife, Ellen, as always, for her patience and editorial assistance.</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429933148_ack01.vue?46c448e9